import { ColumnHelper } from "@tanstack/react-table";
import {
  isOpenVacancyItem,
  SuggestedWmTableItem
} from "PFApp/activities/manage_roles/parts/suggested_wm_side_panel/suggested_shortlists_table/types";
import { Typography } from "PFComponents/typography";
import { CustomType } from "PFTypes";

import { CustomCell } from "./custom_cell";

export const createCustomColumn = (
  columnHelper: ColumnHelper<SuggestedWmTableItem>,
  customType: CustomType,
  getValue: (profile: { pills: { customTypeId: number; text: string }[] }) => string | undefined
) =>
  columnHelper.accessor((row) => row, {
    id: customType.name,
    header: () => (
      <Typography withMargin variant="labelRegular">
        {customType.display_as ?? ""}
      </Typography>
    ),
    cell: (info) => {
      const item = info.row.original;
      if (isOpenVacancyItem(item)) {
        return null;
      }
      return <CustomCell value={getValue(item.profile)} />;
    },
    enableSorting: true,
    sortingFn: (rowA, rowB) => {
      const customValueA = isOpenVacancyItem(rowA.original)
        ? ""
        : (getValue(rowA.original.profile)?.toLowerCase() ?? "");
      const customValueB = isOpenVacancyItem(rowB.original)
        ? ""
        : (getValue(rowB.original.profile)?.toLowerCase() ?? "");
      return customValueA.localeCompare(customValueB);
    },
    sortUndefined: "last"
  });
